module.exports = __webpack_public_path__ + "../assets/mobile-3.jpg";